// extracted by mini-css-extract-plugin
export default {"sectionContainer":"styles_sectionContainer__vthce","letter":"styles_letter__U6+ku"};